import React from 'react';
import { UserBreakdown as UserBreakdownData } from 'src/shared/types';

type UserBreakdownProps = {
    users: UserBreakdownData;
};

const UserBreakdown = ({ users }: UserBreakdownProps) => {
    const addsUp = users.internal + users.external === users.total;

    if (!addsUp) {
        return (
            <span role='alert' className='text-sm text-red-100'>
                {users.internal} internal / {users.external} external — does not sum to {users.total}
            </span>
        );
    }

    return (
        <span className='text-sm text-grey-70'>
            {users.internal} internal / {users.external} external
        </span>
    );
};

export default UserBreakdown;
